import { createContext, useContext } from 'react';
import { UserAPI } from '@shared/types';
import { BookingStep } from './types';

export interface BookingState {
  // Current step
  bookingStep: BookingStep;

  // Location selection
  selectedCity: string;
  selectedNeighborhood: any | null;
  selectedEventId: string;
  
  // Booking details
  specialRequests: UserAPI.SpecialRequests;
  
  // Reservation data (full response from API)
  reservationData: UserAPI.CreateReservationResponseData | null;
  
  // Editing state
  isEditMode: boolean;
  existingBooking: UserAPI.Reservation | null;
  
  // Data
  profile: any;
  allEvents: any[];
  neighborhoods: any[];
  selectedEvent: any | null;
  isLoading: boolean;
  neighborhoodsLoading: boolean;
  
  // Actions
  setSelectedCity: (city: string) => void;
  setSelectedNeighborhood: (neighborhood: any) => void;
  setSelectedEventId: (eventId: string) => void;
  setSpecialRequests: (details: UserAPI.SpecialRequests) => void;
  // No-show disclaimer (no_show_disclaimer experiment). When true the screens
  // show the notice next to the CTA and the booking is stamped as accepted.
  noShowDisclaimerShown: boolean;
  handleCreateReservation: () => void;
  handlePaymentSuccess: () => void;
  handlePaymentCancel: () => void;
  handleSuccessDashboard: () => void;
  handleSuccessBookAnother: () => void;
  
  // Mutation states
  isCreatingReservation: boolean;
}

export const BookingContext = createContext<BookingState | undefined>(undefined);

export function useBookingContext() {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
}

export function useCurrentBookingId(): string | undefined {
  const id = useContext(BookingContext)?.reservationData?.booking.id;
  return id;
}

